import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getProviderOtherSourceItems } from "store/provider-dashboard/provider-dashboard-action"
import { useSearchParams } from "react-router-dom"
import ProviderOtherSourceItemsList from "components/ProviderDashboard/ProviderItems/ProviderOtherSourceItemsList"
import { providerDashboardAction } from "store/provider-dashboard/provider-dashboard-slice"

const ProviderOtherSourceItems = () => {
  const dispatch = useDispatch()

  const [searchParams] = useSearchParams()

  // get params from url parameter
  const getParams = {
    itemId: searchParams.get("itemId"),
    from: searchParams.get("from") !== "null" ? searchParams.get("from") : null,
    to: searchParams.get("to") !== "null" ? searchParams.get("to") : null,
    type: searchParams.get("type"),
  }
  const type = searchParams.get("type")
  const ProviderOtherSourceItems = useSelector(
    state => state.providerDashboard.ProviderOtherSourceItems
  )

  // get other source receipts based params
  useEffect(() => {
    dispatch(getProviderOtherSourceItems(getParams))

    return () => {
      dispatch(providerDashboardAction.resetProviderOtherSourceItems())
    }
  }, [])

  return (
    // Provider Other Source Receipt Item list components
    <ProviderOtherSourceItemsList
      data={ProviderOtherSourceItems?.data?.data}
      loading={ProviderOtherSourceItems?.loading}
      type={type}
    />
  )
}

export default ProviderOtherSourceItems
